import base from './base';

const exportAPI = dispatch => {
    return {
        async exportToFile(code) {
            const response = await base.exportAPI(dispatch, {
                path: `/export/statements/${code}`,
                method: 'GET',
                headers: {
                    Accept: 'application/octet-stream',
                },
            });

            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${code}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }
    }
}


export default exportAPI;